export type Language = "en" | "es" | "fr" | "zh" | "ar" | "pt" | "hi" | "sw" | "yo" | "ig" | "ha";

export const SUPPORTED_LANGUAGES: Language[] = [
  "en",
  "es",
  "fr",
  "zh",
  "ar",
  "pt",
  "hi",
  "sw",
  "yo",
  "ig",
  "ha",
];

export const LANGUAGE_LABELS: Record<Language, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  zh: "中文",
  ar: "العربية",
  pt: "Português",
  hi: "हिन्दी",
  sw: "Kiswahili",
  yo: "Yorùbá",
  ig: "Igbo",
  ha: "Hausa",
};
